<script lang="ts">
  import TextNew, { TEXT_SIZES, TEXT_WEIGHTS, TEXT_FONTS } from "../components/TextNew.svelte";

  const ocrSizes = ["s", "m", "l", "xl"];
</script>

<main class="main">
  {#each TEXT_FONTS as font}
    {#each TEXT_SIZES as size}
      {#each TEXT_WEIGHTS as weight}
        {#if (font === "ocr" && ocrSizes.includes(size)) || font !== "ocr"}
          <div class="box">
            <div class="square" />
            <div>
              <TextNew {font} {size} {weight}>
                {font}
                {size}
                {weight}
              </TextNew>
            </div>
          </div>
        {/if}
      {/each}
    {/each}
  {/each}
</main>

<style>
  .main {
    padding: 24px;
    height: 100%;
    width: 100%;
    overflow: scroll;
  }

  .box {
    display: flex;
    align-items: center;
    border: 1px solid black;
    padding: 16px;
    margin: 16px 0;
  }

  .square {
    width: 24px;
    height: 24px;
    border: 2px solid red;
    margin-right: 8px;
  }
</style>
